/**
 * House of Virasaat — Wishlist
 * localStorage-based, no app required.
 *
 * Wraps the theme's existing button/icon inside <xo-wishlist-toggle>,
 * matching the xo-cart-add pattern already used in product-card.liquid.
 * Render it via: {% render 'hov-wishlist-toggle', product: product %}
 *
 * Header icon needs: id="hov-wishlist-count" (a <span> inside the link)
 * to show a live count badge. Optional — omit if you don't want a badge.
 *
 * Wishlist page needs a container: id="hov-wishlist-list"
 * plus an empty-state element: id="hov-wishlist-empty"
 */
(function () {
  var STORAGE_KEY = 'hov_wishlist';
  var TOGGLE_SELECTOR = 'xo-wishlist-toggle';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* localStorage unavailable — fail silently */
    }
  }

  function toggleWishlist(el) {
    var id = el.getAttribute('xo-product-id');
    if (!id) return;

    var items = getWishlist();

    if (items[id]) {
      delete items[id];
      el.classList.remove('is-active');
    } else {
      items[id] = {
        id: id,
        handle: el.getAttribute('xo-product-handle') || '',
        title: el.getAttribute('xo-product-title') || '',
        image: el.getAttribute('xo-product-image') || '',
        price: el.getAttribute('xo-product-price') || '',
        url: el.getAttribute('xo-product-url') || '#'
      };
      el.classList.add('is-active');
    }

    saveWishlist(items);
    updateAllToggleStates();
    updateCountBadge();
    renderWishlistPage();
  }

  function updateAllToggleStates() {
    var items = getWishlist();
    document.querySelectorAll(TOGGLE_SELECTOR).forEach(function (el) {
      var id = el.getAttribute('xo-product-id');
      el.classList.toggle('is-active', !!(id && items[id]));
    });
  }

  function updateCountBadge() {
    var items = getWishlist();
    var count = Object.keys(items).length;
    document.querySelectorAll('#hov-wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function renderWishlistPage() {
    var list = document.getElementById('hov-wishlist-list');
    var empty = document.getElementById('hov-wishlist-empty');
    if (!list) return;

    var items = getWishlist();
    var keys = Object.keys(items);

    if (keys.length === 0) {
      list.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }

    if (empty) empty.style.display = 'none';

    list.innerHTML = keys.map(function (id) {
      var item = items[id];
      return (
        '<div class="hov-wishlist-card">' +
          '<a href="' + item.url + '" class="hov-wishlist-card__media">' +
            (item.image ? '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="hov-wishlist-card__info">' +
            '<a href="' + item.url + '" class="hov-wishlist-card__title">' + item.title + '</a>' +
            (item.price ? '<span class="hov-wishlist-card__price">' + item.price + '</span>' : '') +
          '</div>' +
          '<button type="button" class="hov-wishlist-card__remove" data-remove-id="' + id + '" aria-label="Remove from wishlist">&times;</button>' +
        '</div>'
      );
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest(TOGGLE_SELECTOR);
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(toggle);
      return;
    }

    var removeBtn = e.target.closest('[data-remove-id]');
    if (removeBtn) {
      e.preventDefault();
      var items = getWishlist();
      delete items[removeBtn.getAttribute('data-remove-id')];
      saveWishlist(items);
      updateAllToggleStates();
      updateCountBadge();
      renderWishlistPage();
    }
  }, true); // capture phase — fires before the theme's own button/link handlers

  document.addEventListener('DOMContentLoaded', function () {
    updateAllToggleStates();
    updateCountBadge();
    renderWishlistPage();
  });

  // Re-sync whenever new content loads dynamically (quick-add, section rendering, etc.)
  document.addEventListener('shopify:section:load', function () {
    updateAllToggleStates();
    updateCountBadge();
  });
})();
